import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { AvatarCircle, AvatarText } from './styles';

const Avatar = ({
  color,
  firstName,
  height,
  width,
}) => (
  <AvatarCircle
    color={color}
    height={height}
    width={width}
  >
    <AvatarText>
      {_.chain(firstName).first().upperCase().value()}
    </AvatarText>
  </AvatarCircle>
);

Avatar.defaultProps = {
  color: null,
  height: '40px',
  width: '40px',
};

Avatar.propTypes = {
  color: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default Avatar;
